
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';


import { getSettings, setSettings, navigateTo, setStatus, clearSelectedPatient } from '../../redux/actions'


import { MenuItem, Select, Button } from '@material-ui/core';

import Loading from '../common/loading';
import BackToPage from '../common/back-to-page';
import {patientGoalBaseStyles } from '../../theme/style';
import AdminLayout from '../user/admin/AdminLayout';
import {map } from 'lodash';
import {  statusTypes } from '../../utils/CFuncs';
import { urls } from '../../utils/Objects';
import Alerts from '../common/Alerts';

const getStatusList = (numLim) =>{
    return Object.keys(statusTypes).map((key,index)=>({
        id:key,
        name:statusTypes[key]
    })).slice(0,numLim)
}  
class PatientStatus extends Component {

    state = {
        new: false,
        status: {id:0,name:'InActive'},
        statusList:getStatusList(),
        isSettingStatus: false,
        statusText:"",
        isStatusChanged:false
    };

    componentDidMount() {
        const {prevPage,user} = this.props.history.location.state
        const itemsAmount = prevPage === urls.patients || prevPage === urls.patientDetails ? 6 : 2
        const statusList = getStatusList(itemsAmount);
        const statusNum = user.status
        this.setState({
            status:{id:statusNum,name:statusTypes[statusNum]},
            statusList
        })
        
       

    }



   
    handleStatusChange = target => {
        this.setState({isStatusChanged:true})
        this.setState({ status:{id:target.value,name:statusTypes[target.value]} })
        

    };


    doneText = () => {
         this.setState({ statusText: "Done" })
    }

    handleSave = () => {
        this.setState({ isSettingStatus: true, statusText:"Updating..." })

        this.props.setStatus(this.props.user.id, this.state.status.id , this.doneText.bind(this))
        const userFromState = this.props.history.location.state.user
        const updateUserState = {...userFromState , status:this.state.status.id}

        this.props.nav.history.push(urls.patientStatus,{user:updateUserState})
    };


    render() {
        let name_display = this.props.user.first_name;
        let birth_date_display = this.props.user.birth_date;

        return (<AdminLayout {...this.props}>
    <Alerts />
            <section style={patientGoalBaseStyles.container}>
                <div navstyle={patientGoalBaseStyles.navstyle}>
                    <BackToPage link={this.props.prevPage} text={this.props.prevPage} />
        
                </div>

                <div style={patientGoalBaseStyles.patientName}>
                    {name_display}
                </div>
                <div style={patientGoalBaseStyles.birthDate}>
                    Birth Date: &nbsp;
                    {moment(birth_date_display).format('MMM D,YYYY')}
                </div>



                <div style={patientGoalBaseStyles.compliance}>
   
                    <Select
                        value={this.state.status.id}
                        onChange={(e) => this.handleStatusChange(e.target)}
                        autoWidth={true}
                        style={{
                            textAlign: 'center',
                            width: '65%',
                            maxWidth: '400px',
                            margin: '10px',
                        }}
                    >
                        {this.state.statusList.map((status,index) => {
                            return (<MenuItem value={status.id} key={status.id}>{status.name}</MenuItem>);
                        })}
                    </Select>
                
                    <section style={patientGoalBaseStyles.btns}>
                        <Button
                            color="primary"
                            variant="contained"
                            style={patientGoalBaseStyles.saveBtn}
                            onClick={this.handleSave}
                            disabled={!this.state.isStatusChanged}
                        >
                            {this.state.new ? 'Save' : 'Update'}
                        </Button>
                    </section>
                    {(this.state.isSettingStatus) && <text style={{ color:"green" }} >{this.state.statusText}</text> }
                </div>
            </section>
        </AdminLayout>);
    }


}





const mapStateToProps = (state, ownProps) => {
    const {user,prevPage} = ownProps.location.state;
    return (
        {
            nav:state.nav,
            login: state.login,
             user,
            prevPage
        }
    )
}


const mapDispatchToProps = {

    navigateTo,
    getSettings,
    setSettings,
    setStatus,
    clearSelectedPatient
}
export default connect(mapStateToProps, mapDispatchToProps)(PatientStatus)	